// src/utils/toast.js
import { message, notification, Modal } from "antd";

/** Lightweight toasts (top-right by default via ConfigProvider) */
export const toastSuccess = (msg = "Operation successful") =>
  message.success({ content: msg, duration: 3 });

export const toastError = (msg = "Something went wrong") =>
  message.error({ content: msg, duration: 3 });

export const toastInfo = (msg = "Heads up") =>
  message.info({ content: msg, duration: 3 });

export const toastWarning = (msg = "Please check") =>
  message.warning({ content: msg, duration: 3 });

/** Loading toast. Returns a function to close it */
export const toastLoading = (msg = "Loading…") => {
  const hide = message.loading({ content: msg, duration: 0 });
  return hide; // call hide() to close
};

/** Rich notifications (optional) */
export const notify = ({
  type = "info", // 'success' | 'info' | 'warning' | 'error'
  message: title = "Notification",
  description,
  btn,
  duration = 4.5,
}) => notification[type]({ message: title, description, btn, duration });

/** Confirm dialog helper (optional) */
export const confirm = ({
  title = "Are you sure?",
  content = "",
  okText = "OK",
  cancelText = "Cancel",
  onOk,
  onCancel,
  okType = "primary",
  centered = true,
}) =>
  Modal.confirm({
    title,
    content,
    okText,
    cancelText,
    onOk,
    onCancel,
    okType,
    centered,
  });
